module.exports = __webpack_public_path__ + "img/9.e8c71364.png";